_ = require 'underscore'

{ Storage } = require '@trello/storage'

warningTemplate = require 'app/scripts/views/templates/board_header_warnings'
Limits = require 'app/scripts/lib/limits'
Util = require 'app/scripts/lib/util'

module.exports.renderBoardWarnings = ->
  $warnings = @$('.js-board-warnings')

  perBoardLimits = Limits.sort(
    Limits.filterByKeys(@model.get('limits'), [
      'cards.openPerBoard',
      'cards.totalPerBoard',
      'checklists.perBoard',
      'labels.perBoard',
      'lists.openPerBoard',
      'lists.totalPerBoard',
      'attachments.perBoard',
    ]).filter (l) -> l.status != 'ok'
  )
  templateMap = {
    'cards.openPerBoard': 'open-cards-per-board-limit',
    'cards.totalPerBoard': 'total-cards-per-board-limit',
    'checklists.perBoard': 'checklists-per-board-limit',
    'labels.perBoard': 'labels-per-board-limit',
    'lists.openPerBoard': 'open-lists-per-board-limit',
    'lists.totalPerBoard': 'total-lists-per-board-limit',
    'attachments.perBoard': 'attachments-per-board-limit',
  }
  isEditable = @model.editable()
  minDismiss = Util.dateBefore(months: 6)
  warnings = perBoardLimits.map (limit) ->
    name = limit.key
    status = if limit.status == "warn"
      "warn"
    else
      "disabled"
    key = "#{templateMap[limit.key]}-#{status}"
    test = => isEditable
    [name, { key, test, minDismiss }]

  dismissWarningName = (name) =>
    "BoardWarning-#{name}-#{ @model.id }"

  warning = _.chain(warnings)
    .filter ([name, { test, minDismiss }]) ->
      if test()
        dismissed = Storage.get(dismissWarningName(name))
        !dismissed || dismissed < minDismiss
    .map ([name, { key }]) ->
      { name, key, dismiss: dismissWarningName(name) }
    .first()
    .value()

  _.chain(warnings)
  .filter ([name, { test }]) ->
    !test() && Storage.get(dismissWarningName(name))?
  .each ([name]) ->
    Storage.unset(dismissWarningName(name))
  .value()

  if warning
    $warnings.removeClass('hide').html warningTemplate({
      canDismiss: Storage.isEnabled(),
      warning
    })
  else
    $warnings.addClass('hide')

  @
